import { render, staticRenderFns } from "./ByTypeOfContent.vue?vue&type=template&id=49465494&"
import script from "./ByTypeOfContent.vue?vue&type=script&lang=js&"
export * from "./ByTypeOfContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports